import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Modal, Button, ButtonToolbar } from 'react-bootstrap';
import { Translate, I18n } from 'react-redux-i18n';
import { head, map, any, propEq, pipe, values } from 'ramda';
import moment from 'moment';
import { validate } from 'spected';
import { css } from 'glamor';
import LabelReviewValidationForm from './LabelReviewValidationForm';
import BaseLoader from '../../../_Common/BaseLoader';

const verify = validate(
  () => ({
    isError: false,
    description: undefined,
  }),
  errors => ({
    isError: true,
    description: head(errors),
  }),
);

const parseMomentToString = value => {
  if (!moment.isMoment(value)) return value;
  return value.format();
};

const isAnyError = pipe(values, any(propEq('isError', true)));

const styles = {
  buttonPanel: css({
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '0px',
    marginBottom: '0px',
    marginRight: '17px',
    marginLeft: '17px',
  }),
};

class LabelReviewValidationModal extends Component {
  constructor(props) {
    super(props);
    const currentDate = moment();
    this.state = {
      currentuser: this.props.currentUser,
      validatedOn: currentDate,
      sentOn: currentDate,
      comment: undefined,
      isValidated: false,
    };
  }

  updateFor = key => value =>
    this.setState(() => ({
      [key]: value,
    }));

  handleSubmit = () => {
    this.props.onSave(map(parseMomentToString, this.state));
  };

  isValidDate = [[value => moment(value).isValid(), I18n.t('form.validDateError')]];

  validationRules = {
    validatedOn: this.isValidDate,
    sentOn: this.isValidDate,
  };

  render() {
    const { closeModal, title, isLoading, currentUser, ...otherProps } = this.props;
    const errors = verify(this.validationRules, this.state);
    const hasErrors = isAnyError(errors);
    return (
      <div>
        <Modal.Header closeButton>
          <Modal.Title>
            {title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <BaseLoader isLoading={isLoading}>
            <LabelReviewValidationForm {...otherProps} {...this.state} updateFor={this.updateFor} errors={errors} />
          </BaseLoader>
        </Modal.Body>
        <Modal.Footer>
          <div className={styles.buttonPanel}>
            <ButtonToolbar>
              <Button bsSize="small" bsStyle="danger" type="button" onClick={closeModal}>
                <i className="fa fa-times" />&nbsp;
                <Translate value="general.close" />
              </Button>
              <Button
                bsSize="small"
                bsStyle="success"
                type="button"
                disabled={hasErrors || isLoading}
                onClick={this.handleSubmit}
              >
                <Translate value="general.save" />&nbsp;
                <i className="fa fa-floppy-o" aria-hidden="true" />
              </Button>
            </ButtonToolbar>
          </div>
        </Modal.Footer>
      </div>
    );
  }
}

LabelReviewValidationModal.defaultProps = {
  title: 'Label Review Validation',
};

LabelReviewValidationModal.propTypes = {
  title: PropTypes.string,
  closeModal: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default LabelReviewValidationModal;
